import React from "react";

const PostReqContent = ({ data }) => {
  if (!data) return null;

  return (
    <>
      <h1>{data.title}</h1>
      <div dangerouslySetInnerHTML={{ __html: data.description }} />
    </>
  );
};

export default PostReqContent;
